import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs'
import { Document } from 'src/app/shared/models/signature.model';

@Injectable({
  providedIn: 'root'
})
export class VerifySignatureBehaviorService {

  private dataSource = new BehaviorSubject<Document>(
    {
      'uid': '',
      'historic': [],
      'uidSigned': '',
      'sha256':'',
      'phaseOut':false,
      'checkBtn': false,
      'file': {
        'name': '',
        'size': '',
        'type': '',
        'file': ''
      },
      'subscribers': [],
      'subscriber': {
        'uid': '',
        'email': '',
        'fullName': '',
        'signed': false,
        'type': '',
        'signature': {
          'uid':''
        }
      }
    }
  )

  data = this.dataSource.asObservable();

  constructor() { }

  setData(data:Document){
    this.dataSource.next(data);
  }
}
